import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=45a113d2&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a113d2",
  null
  
)

export default component.exports